// Enums.
import ciap from '@/enums/geral/ciap'
import cid from '@/enums/geral/cid'

export default {
    computed: {
        ciapsGravidez() {
            return {
                normal: [
                    this.enums.ciap.GRAVIDEZ,
                ],
                altoRisco: [
                    this.enums.ciap.DIABETES_GESTACIONAL,
                    this.enums.ciap.GRAVIDEZ_DE_ALTO_RISCO,
                    this.enums.ciap.GRAVIDEZ_ECTOPICA,
                    this.enums.ciap.GRAVIDEZ_NAO_DESEJADA,
                    this.enums.ciap.INFECCOES_QUE_COMPLICAM_A_GRAVIDEZ,
                    this.enums.ciap.TOXEMIA_GRAVIDICA_DHEG,
                ],
                desfecho: [
                    this.enums.ciap.ABORTO_ESPONTANEO,
                    this.enums.ciap.ABORTO_PROVOCADO,
                    this.enums.ciap.PARTO_SEM_COMPLICACOES_DE_NASCIDO_VIVO,
                    this.enums.ciap.PARTO_SEM_COMPLICACOES_DE_NATIMORTO,
                    this.enums.ciap.PARTO_COM_COMPLICACOES_DE_NASCIDO_VIVO,
                    this.enums.ciap.PARTO_COM_COMPLICACOES_DE_NATIMORTO,
                ],
            }
        },
        cidsGravidez() {
            return {
                normal: [
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_NORMAL,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_NORMAL_NAO_ESPECIFICADA,
                    this.enums.cid.SUPERVISAO_DE_OUTRA_GRAVIDEZ_NORMAL,
                    this.enums.cid.SUPERVISAO_DE_PRIMEIRA_GRAVIDEZ_NORMAL,
                ],
                altoRisco: [
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ESTERILIDADE,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ABORTO,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_OUTROS_ANTECEDENTES_DE_PROCRIACAO_PROBLEMATICA,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ASSISTENCIA_PRE_NATAL_INSUFICIENTE,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_GRANDE_MULTIPARIDADE,
                    this.enums.cid.SUPERVISAO_DE_PRIMIGESTA_IDOSA,
                    this.enums.cid.SUPERVISAO_DE_PRIMIGESTA_MUITO_JOVEM,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO_DEVIDO_A_PROBLEMAS_SOCIAIS,
                    this.enums.cid.SUPERVISAO_DE_OUTRAS_GRAVIDEZES_DE_ALTO_RISCO,
                    this.enums.cid.SUPERVISAO_NAO_ESPECIFICADA_DE_GRAVIDEZ_DE_ALTO_RISCO,
                ],
                desfecho: [
                    this.enums.cid.NASCIDOS_VIVOS_SEGUNDO_O_LOCAL_DE_NASCIMENTO,
                    this.enums.cid.OUTROS_PRODUTOS_ANORMAIS_DA_CONCEPCAO,
                    this.enums.cid.OVO_CLARO_E_MOLA_NAO_HIDATIFORME,
                    this.enums.cid.ABORTO_RETIDO,
                    this.enums.cid.OUTROS_PRODUTOS_ANORMAIS_DA_CONCEPCAO_ESPECIFICADOS,
                    this.enums.cid.PRODUTO_ANORMAL_DA_CONCEPCAO_NAO_ESPECIFICADO,
                    this.enums.cid.ABORTO_ESPONTANEO,
                    this.enums.cid.ABORTO_ESPONTANEO_INCOMPLETO_COMPLICADO_POR_INFECCAO_DO_TRATO_GENITAL_OU_DOS_ORGAOS_PELVICOS,
                    this.enums.cid.ABORTO_ESPONTANEO_INCOMPLETO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.ABORTO_ESPONTANEO_INCOMPLETO_COMPLICADO_POR_EMBOLIA,
                    this.enums.cid.ABORTO_ESPONTANEO_INCOMPLETO_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIFICADAS,
                    this.enums.cid.ABORTO_ESPONTANEO_INCOMPLETO_SEM_COMPLICACOES,
                    this.enums.cid.ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COMPLICADO_P_INFEC_DO_TRATO_GENITAL_OU_ORG_PELVICOS,
                    this.enums.cid.ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COMPLICADO_P_HEMOR_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COMPLICADO_P_EMBOLIA,
                    this.enums.cid.ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIF,
                    this.enums.cid.ABORTO_ESPONTANEO_COMPLETO_OU_NAO_ESPEC_SEM_COMPLICACOES,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_E_LEGAIS,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COMPLICADO_P_INFEC_DO_TRATO_GENITAL_OU_ORG_PELVICOS,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COMPLICADO_POR_EMBOLIA,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_COM_OUTRAS_COMPLIC_OU_COM_COMPLIC_NAO_ESPECIFICADAS,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_INCOMPL_SEM_COMPLICACOES,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_N_ESPEC_COMPLIC_P_INFEC_DO_TRATO_GENIT_ORG_PELV,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_COMPLIC_P_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_COMPLIC_P_EMBOLIA,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_COM_OUT_COMPLIC_COMPLIC_N_ESPECIFICADAS,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_LEGAIS_COMPL_OU_NAO_ESPEC_SEM_COMPLICACOES,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COMPLICADO_POR_INFECCAO_DO_TRATO_GENITAL_OU_DOS_ORGAOS_PELVICOS,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COMPLICADO_POR_EMBOLIA,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIFICADAS,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_INCOMPLETO_SEM_COMPLICACOES,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLIC_P_INFEC_DO_TRATO_GENIT_ORG_PELV,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLICADO_POR_EMBOLIA,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_COM_OUT_COMPLIC_COMPLIC_NAO_ESPECIFICADAS,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO_COMPLETO_OU_NAO_ESPECIFICADO_SEM_COMPLICACOES,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COMPLICADO_POR_INFEC_DO_TRATO_GENITAL_OU_DOS_ORGAOS_PELVICOS,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COMPLICADO_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COMPLICADO_POR_EMBOLIA,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_INCOMPLETO_COM_OUTRAS_COMPLICACOES_OU_COM_COMPLICACOES_NAO_ESPECIFICADAS,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_INCOMPLETO_SEM_COMPLICACOES,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLIC_P_INFEC_DO_TRATO_GENIT_ORG_PELV,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLIC_POR_HEMORRAGIA_EXCESSIVA_OU_TARDIA,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COMPLICADO_POR_EMBOLIA,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_COM_OUT_COMPLIC_COMPLIC_N_ESPECIFICADAS,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO_COMPLETO_OU_NAO_ESPECIFICADO_SEM_COMPLICACOES,
                    this.enums.cid.RUPTURA_PREMATURA_DE_MEMBRANAS,
                    this.enums.cid.RUPTURA_PREMATURA_DE_MEMBRANAS_COM_INICIO_DO_TRABALHO_DE_PARTO_DENTRO_DE_24_HORAS,
                    this.enums.cid.RUPTURA_PREMATURA_DE_MEMBRANAS_COM_INICIO_DO_TRABALHO_DE_PARTO_DEPOIS_DAS_PRIMEIRAS_24_HORAS,
                    this.enums.cid.RUPTURA_PREMATURA_DE_MEMBRANAS_COM_TRABALHO_DE_PARTO_RETARDADO_POR_TERAPEUTICA,
                    this.enums.cid.RUPTURA_PREMATURA_DE_MEMBRANAS_NAO_ESPECIFICADA,
                    this.enums.cid.DESCOLAMENTO_PREMATURO_DA_PLACENTA_ABRUPTIO_PLACENTAE,
                    this.enums.cid.DESCOLAMENTO_PREMATURO_DA_PLACENTA_COM_DEFICIENCIA_DE_COAGULACAO,
                    this.enums.cid.OUTRO_DESCOLAMENTO_PREMATURO_DA_PLACENTA,
                    this.enums.cid.DESCOLAMENTO_PREMATURO_DA_PLACENTA_NAO_ESPECIFICADO,
                    this.enums.cid.TRABALHO_DE_PARTO_PRE_TERMO,
                    this.enums.cid.TRABALHO_DE_PARTO_PRE_TERMO_COM_PARTO_PRE_TERMO,
                    this.enums.cid.TRABALHO_DE_PARTO_PRE_TERMO_COM_PARTO_A_TERMO,
                    this.enums.cid.FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.FALHA_NA_INDUCAO_MEDICA_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.FALHA_NA_INDUCAO_INSTRUMENTAL_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.OUTRAS_FORMAS_DE_FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO_NAO_ESPECIFICADA,
                    this.enums.cid.ANORMALIDADES_DA_CONTRACAO_UTERINA,
                    this.enums.cid.CONTRACOES_INICIAIS_INADEQUADAS,
                    this.enums.cid.INERCIA_UTERINA_SECUNDARIA,
                    this.enums.cid.OUTRAS_FORMAS_DE_INERCIA_UTERINA,
                    this.enums.cid.TRABALHO_DE_PARTO_PRECIPITADO,
                    this.enums.cid.CONTRACOES_UTERINAS_HIPERTONICAS_INCOORDENADAS_OU_PROLONGADAS,
                    this.enums.cid.OUTRAS_ANORMALIDADES_DA_CONTRACAO_UTERINA,
                    this.enums.cid.ANORMALIDADES_DA_CONTRACAO_UTERINA_NAO_ESPECIFICADAS,
                    this.enums.cid.TRABALHO_DE_PARTO_PROLONGADO,
                    this.enums.cid.PROLONGAMENTO_DO_PRIMEIRO_PERIODO_DILATACAO,
                    this.enums.cid.PROLONGAMENTO_DO_SEGUNDO_PERIODO_EXPULSAO,
                    this.enums.cid.PARTO_RETARDADO_DO_SEGUNDO_GEMEO_DO_TERCEIRO_GEMEO_ETC,
                    this.enums.cid.TRABALHO_DE_PARTO_PROLONGADO_NAO_ESPECIFICADO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_MA_POSICAO_OU_MA_APRESENTACAO_DO_FETO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ROTACAO_INCOMPLETA_DO_POLO_CEFALICO_FETAL,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_PELVICA,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_DE_FACE,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_DE_FRONTE,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_DE_OMBRO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_APRESENTACAO_COMPLEXA,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_OUTRAS_FORMAS_DE_MA_APRESENTACAO_E_MA_POSICAO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_MA_POSICAO_OU_MA_APRESENTACAO_NAO_ESPECIFICADAS,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADE_PELVICA_DA_MAE,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_DEFORMIDADE_PELVICA,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_CONTRACAO_GERAL_DA_PELVE,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_CONTRACAO_DO_ESTREITO_SUPERIOR,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_CONTRACAO_DO_ESTREITO_INFERIOR_OU_DA_CAVIDADE_MEDIANA,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_DESPROPORCAO_FETO_PELVICA_NAO_ESPECIFICADA,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADE_DOS_ORGAOS_PELVICOS_MATERNOS,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_OUTRAS_ANORMALIDADES_PELVICAS_MATERNAS,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADES_PELVICAS_MATERNAS_NAO_ESPECIFICADAS,
                    this.enums.cid.OUTRAS_FORMAS_DE_OBSTRUCAO_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDO_A_DISTOCIA_DE_OMBRO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_POR_COLISAO_DE_GEMEOS,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_POR_FETO_EXCEPCIONALMENTE_GRANDE,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDO_A_OUTRAS_ANORMALIDADES_DO_FETO,
                    this.enums.cid.FALHA_DE_TENTATIVA_DE_TRABALHO_DE_PARTO_NAO_ESPECIFICADA,
                    this.enums.cid.FALHA_DE_APLICACAO_DE_FORCEPS_E_VACUO_EXTRATOR_NAO_ESPECIFICADA,
                    this.enums.cid.OUTRAS_FORMAS_DE_OBSTRUCAO_DO_TRABALHO_DE_PARTO_ESPECIFICADAS,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_NAO_ESPECIFICADO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_HEMORRAGIA_INTRAPARTO_NAO_CLASSIFICADOS_EM_OUTRA_PARTE,
                    this.enums.cid.HEMORRAGIA_INTRAPARTO_COM_DEFICIENCIA_DE_COAGULACAO,
                    this.enums.cid.OUTRAS_HEMORRAGIAS_INTRAPARTO,
                    this.enums.cid.HEMORRAGIA_INTRAPARTO_NAO_ESPECIFICADA,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_SOFRIMENTO_FETAL,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORMALIDADE_DA_FREQUENCIA_CARDIACA_FETAL,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_MECONIO_NO_LIQUIDO_AMNIOTICO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORM_NA_FREQ_CARDIACA_FETAL_C_MECONIO_NO_LIQ_AMNIOTICO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_EVIDENCIAS_BIOQUIMICAS_DE_SOFRIMENTO_FETAL,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_OUTRAS_EVIDENCIAS_DE_SOFRIMENTO_FETAL,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_SOFRIMENTO_FETAL_NAO_ESPECIFICADO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORMALIDADE_DO_CORDAO_UMBILICAL,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_PROLAPSO_DO_CORDAO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_CIRCULAR_DE_CORDAO_COM_COMPRESSAO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_OUTROS_ENOVELAMENTOS_DO_CORDAO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_CORDAO_CURTO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_VASA_PRAEVIA,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_LESAO_VASCULAR_DO_CORDAO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_OUTRAS_COMPLICACOES_DO_CORDAO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_COMPLICACOES_DO_CORDAO_NAO_ESPECIFICADAS,
                    this.enums.cid.LACERACAO_DO_PERINEO_DURANTE_O_PARTO,
                    this.enums.cid.LACERACAO_DE_PERINEO_DE_PRIMEIRO_GRAU_DURANTE_O_PARTO,
                    this.enums.cid.LACERACAO_DE_PERINEO_DE_SEGUNDO_GRAU_DURANTE_O_PARTO,
                    this.enums.cid.LACERACAO_DE_PERINEO_DE_TERCEIRO_GRAU_DURANTE_O_PARTO,
                    this.enums.cid.LACERACAO_DE_PERINEO_DE_QUARTO_GRAU_DURANTE_O_PARTO,
                    this.enums.cid.LACERACAO_DE_PERINEO_DURANTE_O_PARTO_NAO_ESPECIFICADA,
                    this.enums.cid.OUTROS_TRAUMATISMOS_OBSTETRICOS,
                    this.enums.cid.RUPTURA_DO_UTERO_ANTES_DO_INICIO_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.RUPTURA_DO_UTERO_DURANTE_O_TRABALHO_DE_PARTO,
                    this.enums.cid.INVERSAO_DO_UTERO_POS_PARTO,
                    this.enums.cid.LACERACAO_OBSTETRICA_DO_COLO_DO_UTERO,
                    this.enums.cid.LACERACAO_VAGINAL_ALTA_ISOLADA_DE_ORIGEM_OBSTETRICA,
                    this.enums.cid.OUTRAS_LESOES_OBSTETRICAS_AOS_ORGAOS_PELVICOS,
                    this.enums.cid.LESAO_OBSTETRICA_DAS_ARTICULACOES_E_DOS_LIGAMENTOS_PELVICOS,
                    this.enums.cid.HEMATOMA_OBSTETRICO_DA_PELVE,
                    this.enums.cid.OUTROS_TRAUMATISMOS_OBSTETRICOS_ESPECIFICADOS,
                    this.enums.cid.TRAUMATISMO_OBSTETRICO_NAO_ESPECIFICADO,
                    this.enums.cid.RETENCAO_DA_PLACENTA_E_DAS_MEMBRANAS_SEM_HEMORRAGIAS,
                    this.enums.cid.RETENCAO_DA_PLACENTA_SEM_HEMORRAGIA,
                    this.enums.cid.RETENCAO_DE_PARTES_DA_PLACENTA_OU_DAS_MEMBRANAS_SEM_HEMORRAGIA,
                    this.enums.cid.SOFRIMENTO_MATERNO_DURANTE_O_TRABALHO_DE_PARTO_E_O_PARTO,
                    this.enums.cid.CHOQUE_DURANTE_OU_SUBSEQUENTE_AO_TRABALHO_DE_PARTO_E_O_PARTO,
                    this.enums.cid.OUTRAS_COMPLICACOES_DE_PROCEDIMENTOS_OU_DE_CIRURGIA_OBSTETRICA,
                    this.enums.cid.DEMORA_DO_PARTO_APOS_RUPTURA_ARTIFICIAL_DAS_MEMBRANAS,
                    this.enums.cid.DEMORA_DO_PARTO_APOS_RUPTURA_ESPONTANEA_OU_NAO_ESPECIFICADA_DAS_MEMBRANAS,
                    this.enums.cid.PARTO_VAGINAL_SUBSEQUENTE_A_CESARIANA_ANTERIOR,
                    this.enums.cid.OUTRAS_COMPLICACOES_ESPECIFICADAS_DO_TRABALHO_DE_PARTO_E_DO_PARTO,
                    this.enums.cid.COMPLICACOES_DO_TRABALHO_DE_PARTO_E_DO_PARTO_NAO_ESPECIFICADAS,
                    this.enums.cid.PARTO_UNICO_ESPONTANEO,
                    this.enums.cid.PARTO_ESPONTANEO_CEFALICO,
                    this.enums.cid.PARTO_ESPONTANEO_PELVICO,
                    this.enums.cid.OUTROS_TIPOS_DE_PARTO_UNICO_ESPONTANEO,
                    this.enums.cid.PARTO_UNICO_ESPONTANEO_NAO_ESPECIFICADO,
                    this.enums.cid.PARTO_UNICO_POR_FORCEPS_OU_VACUO_EXTRATOR,
                    this.enums.cid.PARTO_POR_FORCEPS_BAIXO,
                    this.enums.cid.PARTO_POR_FORCEPS_DA_CAVIDADE_MEDIANA,
                    this.enums.cid.FORCEPS_DA_CAVIDADE_MEDIANA_COM_ROTACAO,
                    this.enums.cid.OUTROS_TIPOS_DE_PARTO_POR_FORCEPS_E_OS_NAO_ESPECIFICADOS,
                    this.enums.cid.PARTO_POR_VACUO_EXTRATOR,
                    this.enums.cid.PARTO_POR_COMBINACAO_DE_FORCEPS_E_VACUO_EXTRATOR,
                    this.enums.cid.PARTO_UNICO_POR_CESARIANA,
                    this.enums.cid.PARTO_POR_CESARIANA_ELETIVA,
                    this.enums.cid.PARTO_POR_CESARIANA_DE_EMERGENCIA,
                    this.enums.cid.PARTO_POR_CESARIANA_PARA_HISTERECTOMIA,
                    this.enums.cid.OUTROS_TIPOS_DE_PARTO_UNICO_POR_CESARIANA,
                    this.enums.cid.PARTO_POR_CESARIANA_NAO_ESPECIFICADA,
                    this.enums.cid.OUTROS_TIPOS_DE_PARTO_UNICO_ASSISTIDO,
                    this.enums.cid.EXTRACAO_PELVICA,
                    this.enums.cid.OUTROS_TIPOS_DE_PARTO_PELVICO_ASSISTIDO,
                    this.enums.cid.OUTRAS_FORMAS_DE_PARTO_COM_O_AUXILIO_DE_MANIPULACAO,
                    this.enums.cid.PARTO_DE_GRAVIDEZ_INTRA_ABDOMINAL_COM_FETO_VIAVEL,
                    this.enums.cid.CIRURGIA_DESTRUTIVA_PARA_FACILITAR_O_PARTO,
                    this.enums.cid.OUTROS_TIPOS_ESPECIFICADOS_DE_PARTO_UNICO_ASSISTIDO,
                    this.enums.cid.PARTO_UNICO_ASSISTIDO_NAO_ESPECIFICADO,
                    this.enums.cid.PARTO_MULTIPLO,
                    this.enums.cid.PARTO_MULTIPLO_TODOS_ESPONTANEOS,
                    this.enums.cid.PARTO_MULTIPLO_TODOS_POR_FORCEPS_OU_VACUO_EXTRATOR,
                    this.enums.cid.PARTO_MULTIPLO_TODOS_POR_CESARIANA,
                    this.enums.cid.OUTRO_TIPO_DE_PARTO_MULTIPLO,
                    this.enums.cid.PARTO_MULTIPLO_NAO_ESPECIFICADO,
                    this.enums.cid.EXTRACAO_MENSTRUAL,
                    this.enums.cid.RESULTADO_DO_PARTO,
                    this.enums.cid.NASCIMENTO_UNICO_NATIVIVO_NADO_VIVO,
                    this.enums.cid.NASCIMENTO_UNICO_NATIMORTO_FETO_MORTO,
                    this.enums.cid.NASCIMENTO_GEMELAR_GEMEOS_AMBOS_NATIVIVOS_NADO_VIVOS,
                    this.enums.cid.NASCIMENTO_GEMELAR_UM_DOS_GEMEOS_NATIVIVO_NADO_VIVO_O_OUTRO_NATIMORTO_FETO_MORTO,
                    this.enums.cid.NASCIMENTO_GEMELAR_GEMEOS_NATIMORTOS_FETO_MORTOS,
                    this.enums.cid.OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIVIVOS_NADO_VIVOS,
                    this.enums.cid.OUTROS_NASCIMENTOS_MULTIPLOS_ALGUNS_NATIVIVOS_NADO_VIVOS,
                    this.enums.cid.OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIMORTOS_FETO_MORTOS,
                    this.enums.cid.NASCIMENTO_NAO_ESPECIFICADO,
                    this.enums.cid.ASSISTENCIA_E_EXAME_POS_NATAL,
                    this.enums.cid.ASSISTENCIA_E_EXAME_IMEDIATAMENTE_APOS_O_PARTO,
                    this.enums.cid.ASSISTENCIA_E_EXAME_DA_MAE_NUTRIZ,
                    this.enums.cid.SEGUIMENTO_POS_PARTO_DE_ROTINA,
                ],
            }
        },
    },
    data: () => ({
        enums: {ciap, cid},
    }),
    methods: {
        isGravidezNormal(item) {
            let isCiapGravidezNormal = false
            let isCidGravidezNormal = false

            if (item.ciap) {
                isCiapGravidezNormal = this.ciapsGravidez.normal.includes(item.ciap.codigo)
            }

            if (item.cid) {
                isCidGravidezNormal = this.cidsGravidez.normal.includes(item.cid.codigo)
            }

            return isCiapGravidezNormal || isCidGravidezNormal
        },
        isGravidezAltoRisco(item) {
            let isCiapGravidezAltoRisco = false
            let isCidGravidezAltoRisco = false

            if (item.ciap) {
                isCiapGravidezAltoRisco = this.ciapsGravidez.altoRisco.includes(item.ciap.codigo)
            }

            if (item.cid) {
                isCidGravidezAltoRisco = this.cidsGravidez.altoRisco.includes(item.cid.codigo)
            }

            return isCiapGravidezAltoRisco || isCidGravidezAltoRisco
        },
        isDesfechoGravidez(item) {
            let isCiapDesfechoGravidez = false
            let isCidDesfechoGravidez = false

            if (item.ciap) {
                isCiapDesfechoGravidez = this.ciapsGravidez.desfecho.includes(item.ciap.codigo)
            }

            if (item.cid) {
                isCidDesfechoGravidez = this.cidsGravidez.desfecho.includes(item.cid.codigo)
            }

            return isCiapDesfechoGravidez || isCidDesfechoGravidez
        },
    },
}